import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white stats-item" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 pt-lg-30 letter-spacing" };
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between mb-15" };
const _hoisted_4 = { class: "fs-13 d-block text-uppercase text-dark-emphasis fw-bold" };
const _hoisted_5 = { class: "text-muted d-block" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = { class: "row justify-content-between" };
const _hoisted_8 = { class: "col-md-6 mb-4" };
const _hoisted_9 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_10 = { class: "col-md-6 mb-4" };
const _hoisted_11 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_12 = { class: "row justify-content-between" };
const _hoisted_13 = { class: "col-md-6 mb-4" };
const _hoisted_14 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_15 = { class: "col-md-6 mb-4" };
const _hoisted_16 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_17 = { class: "row justify-content-between" };
const _hoisted_18 = { class: "col-md-6 mb-4" };
const _hoisted_19 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_20 = { class: "col-md-6 mb-4" };
const _hoisted_21 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_22 = { class: "row justify-content-between" };
const _hoisted_23 = { class: "col-md-6 mb-4" };
const _hoisted_24 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_25 = { class: "col-md-6 mb-4" };
const _hoisted_26 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_27 = {
    key: 0,
    class: "alert alert-danger py-2"
};
const _hoisted_28 = { class: "d-flex align-items-center justify-content-between mt-15" };
const _hoisted_29 = { class: "fs-13 d-block text-uppercase text-dark-emphasis fw-bold" };
const _hoisted_30 = { class: "d-flex align-items-center" };
const _hoisted_31 = { class: "fw-black mb-0 me-10 lh-1" };
const _hoisted_32 = {
    key: 0,
    class: "fw-bold text-success text-badge d-inline-block"
};
const _hoisted_33 = { class: "table-responsive mt-15" };
const _hoisted_34 = { class: "table align-middle mb-0" };
const _hoisted_35 = { class: "text-uppercase fw-medium text-body-tertiary fs-13" };
const _hoisted_36 = { class: "text-uppercase fw-medium text-body-tertiary fs-13" };
const _hoisted_37 = { class: "text-uppercase fw-medium text-body-tertiary fs-13" };
const _hoisted_38 = { class: "text-uppercase fw-medium text-body-tertiary fs-13 text-end" };
const _hoisted_39 = { class: "text-uppercase fw-medium text-body-tertiary fs-13 text-end" };
const _hoisted_40 = { class: "text-uppercase fw-medium text-body-tertiary fs-13 text-end" };
const _hoisted_41 = { key: 0 };
const _hoisted_42 = {
    colspan: "6",
    class: "py-3 text-center"
};
const _hoisted_43 = { key: 1 };
const _hoisted_44 = {
    colspan: "6",
    class: "py-3 text-center text-muted"
};
const _hoisted_45 = { class: "fw-semibold text-black" };
const _hoisted_46 = { class: "text-end" };
const _hoisted_47 = { class: "text-end" };
const _hoisted_48 = { class: "text-end" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('reports.averageBasket.title')), 1),
                    _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.$t('reports.averageBasket.subtitle')), 1)
                ]),
                _createElementVNode("button", {
                    class: "btn btn-outline-secondary btn-sm",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.fetchStats && _ctx.fetchStats(...args))),
                    disabled: _ctx.loading
                }, _toDisplayString(_ctx.$t('common.refresh')), 9, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('forms.start')), 1),
                    _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "form-control shadow-none rounded-0 text-black",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.localStartDate) = $event)),
                        onChange: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchStats && _ctx.fetchStats(...args)))
                    }, null, 544), [
                        [_vModelText, _ctx.localStartDate]
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('forms.end')), 1),
                    _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "form-control shadow-none rounded-0 text-black",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.localEndDate) = $event)),
                        onChange: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchStats && _ctx.fetchStats(...args)))
                    }, null, 544), [
                        [_vModelText, _ctx.localEndDate]
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('forms.startTime')), 1),
                    _withDirectives(_createElementVNode("input", {
                        type: "time",
                        class: "form-control shadow-none rounded-0 text-black",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.startTime) = $event)),
                        onChange: _cache[6] || (_cache[6] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchStats && _ctx.fetchStats(...args)))
                    }, null, 544), [
                        [_vModelText, _ctx.startTime]
                    ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('forms.endTime')), 1),
                    _withDirectives(_createElementVNode("input", {
                        type: "time",
                        class: "form-control shadow-none rounded-0 text-black",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.endTime) = $event)),
                        onChange: _cache[8] || (_cache[8] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchStats && _ctx.fetchStats(...args)))
                    }, null, 544), [
                        [_vModelText, _ctx.endTime]
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('forms.orderType')), 1),
                    _createVNode(_component_v_select, {
                        modelValue: _ctx.orderTypeSelected,
                        "onUpdate:modelValue": [
                            _cache[9] || (_cache[9] = ($event) => ((_ctx.orderTypeSelected) = $event)),
                            _ctx.fetchStats
                        ],
                        options: _ctx.orderTypeOptions,
                        label: "label",
                        reduce: (opt) => opt.value,
                        placeholder: _ctx.$t('forms.orderType')
                    }, null, 8, ["modelValue", "options", "reduce", "placeholder", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('order.paymentMethod')), 1),
                    _createVNode(_component_v_select, {
                        modelValue: _ctx.paymentMethodSelected,
                        "onUpdate:modelValue": [
                            _cache[10] || (_cache[10] = ($event) => ((_ctx.paymentMethodSelected) = $event)),
                            _ctx.fetchStats
                        ],
                        options: _ctx.paymentMethodOptions,
                        label: "label",
                        reduce: (opt) => opt.value,
                        placeholder: _ctx.$t('order.paymentMethod')
                    }, null, 8, ["modelValue", "options", "reduce", "placeholder", "onUpdate:modelValue"])
                ])
            ]),
            _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('order.orderStatus')), 1),
                    _createVNode(_component_v_select, {
                        modelValue: _ctx.orderStatusSelected,
                        "onUpdate:modelValue": [
                            _cache[11] || (_cache[11] = ($event) => ((_ctx.orderStatusSelected) = $event)),
                            _ctx.fetchStats
                        ],
                        options: _ctx.orderStatusOptions,
                        label: "label",
                        reduce: (opt) => opt.value,
                        placeholder: _ctx.$t('order.orderStatus')
                    }, null, 8, ["modelValue", "options", "reduce", "placeholder", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('common.paymentStatus')), 1),
                    _createVNode(_component_v_select, {
                        modelValue: _ctx.paymentStatusSelected,
                        "onUpdate:modelValue": [
                            _cache[12] || (_cache[12] = ($event) => ((_ctx.paymentStatusSelected) = $event)),
                            _ctx.fetchStats
                        ],
                        options: _ctx.paymentStatusOptions,
                        label: "label",
                        reduce: (opt) => opt.value,
                        placeholder: _ctx.$t('common.paymentStatus')
                    }, null, 8, ["modelValue", "options", "reduce", "placeholder", "onUpdate:modelValue"])
                ])
            ]),
            (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_28, [
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('reports.averageBasket.valueLabel')), 1),
                _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.averageBasketDisplay), 1),
                    (_ctx.ordersCount !== null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-up-arrow fs-11 lh-1 position-relative top-1" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.ordersCount) + " " + _toDisplayString(_ctx.$t('forms.orders')), 1)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _createElementVNode("div", _hoisted_33, [
                _createElementVNode("table", _hoisted_34, [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t('forms.orderType')), 1),
                            _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t('order.paymentMethod')), 1),
                            _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.$t('order.orderStatus')), 1),
                            _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.$t('reports.averageBasket.columns.count')), 1),
                            _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.$t('reports.averageBasket.columns.totalAmount')), 1),
                            _createElementVNode("th", _hoisted_40, _toDisplayString(_ctx.$t('reports.averageBasket.columns.averageBasket')), 1)
                        ])
                    ]),
                    _createElementVNode("tbody", null, [
                        (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                                _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.$t('common.loading')), 1)
                            ]))
                            : (_ctx.groups.length === 0)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                                    _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.$t('reports.averageBasket.empty')), 1)
                                ]))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.groups, (g) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: `${g.order_type}-${g.payment_method}-${g.status}`
                                    }, [
                                        _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.translateOrderType(g.order_type)), 1),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.translatePaymentMethod(g.payment_method)), 1),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.translateStatus(g.status)), 1),
                                        _createElementVNode("td", _hoisted_46, _toDisplayString(g.count), 1),
                                        _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.formatCHF(g.total_amount)), 1),
                                        _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.formatCHF(g.average_basket)), 1)
                                    ]));
                                }), 128))
                    ])
                ])
            ])
        ])
    ]));
}
